export const location = {
  add: {
    label: "Add location",
  },
  delete: {
    label: "Delete location",
  },
  form: {
    add: {
      label: "Add location",
    },
    associateLocationWith: "Associate this location with",
    description: {
      label: "Description",
    },
    edit: {
      label: "Edit location",
    },
    informations: "Location information",
    photo: {
      label: "Photo",
    },
    name: {
      label: "Name",
    },
    organization: {
      label: "Organization",
    },
  },
  statistics: {
    interventionsStatus: "Intervention Status",
  },
};
